import { useEffect, useState } from "react";
import axios from "../../../axios";

const AppControls = () => {
  const [loading, setLoading] = useState(false);
  const [settingId, setSettingId] = useState("");
  const [settings, setSettings] = useState({
    minRechargeAmount: 2,
    minWithdrawalAmount: 100,
    latestVersionAndroid: '1.0.0',
    latestVersionIos: '1.0.0',
    minRequiredVersionAndroid: '1.0.0',
    minRequiredVersionIos: '1.0.0',
    playStoreUrl: '',
    appStoreUrl: '',
    tutorialBuyCourse: '',
    tutorialQuiz: '',
    tutorialContest: '',
    tutorialCredits: '',
    tutorialWithdrawal: '',
    howAdhyayiWorks: '',
    showRupees:false,
    freeUserWithdrawalLimit:200,
    NewUserContestJoinLimit:0
  });

  // Fetch existing settings
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get("getAppControlsForAdmin");
        if (res.data.result) {
          const data = res.data.result;
          setSettingId(data._id);
          setSettings({
            minRechargeAmount: data.minRechargeAmount || 2,
            minWithdrawalAmount: data.minWithdrawalAmount || 100,
            latestVersionAndroid: data.latestVersionAndroid || '1.0.0',
            latestVersionIos: data.latestVersionIos || '1.0.0',
            minRequiredVersionAndroid: data.minRequiredVersionAndroid || '1.0.0',
            minRequiredVersionIos: data.minRequiredVersionIos || '1.0.0',
            playStoreUrl: data.playStoreUrl || '',
            appStoreUrl: data.appStoreUrl || '',
            tutorialBuyCourse: data.tutorialBuyCourse || '',
            tutorialQuiz: data.tutorialQuiz || '',
            tutorialContest: data.tutorialContest || '',
            tutorialCredits: data.tutorialCredits || '',
            tutorialWithdrawal: data.tutorialWithdrawal || '',
            howAdhyayiWorks: data.howAdhyayiWorks || '',
            showRupees: data.showRupees || false,
            freeUserWithdrawalLimit:data.freeUserWithdrawalLimit || 200,
           NewUserContestJoinLimit: data.NewUserContestJoinLimit ?? 0,
          });
        }
      } catch (error) {
        console.log("Error:", error);
      }
    };
    fetchSettings();
  }, []);

 const handleChange = (e) => {
   console.log(e.target.name, e.target.value);
  const { name, value, type, checked } = e.target;

  setSettings((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? checked : value,
  }));
};

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const response = await axios.put(`updateAppControls/${settingId}`, {
        minRechargeAmount: Number(settings.minRechargeAmount),
        minWithdrawalAmount: Number(settings.minWithdrawalAmount),
        latestVersionAndroid: settings.latestVersionAndroid,
        latestVersionIos: settings.latestVersionIos,
        minRequiredVersionAndroid: settings.minRequiredVersionAndroid,
        minRequiredVersionIos: settings.minRequiredVersionIos,
        playStoreUrl: settings.playStoreUrl,
        appStoreUrl: settings.appStoreUrl,
        tutorialBuyCourse: settings.tutorialBuyCourse,
        tutorialQuiz: settings.tutorialQuiz,
        tutorialContest: settings.tutorialContest,
        tutorialCredits: settings.tutorialCredits,
        tutorialWithdrawal: settings.tutorialWithdrawal,
        howAdhyayiWorks: settings.howAdhyayiWorks,
        showRupees: settings.showRupees, // <-- Add this
        freeUserWithdrawalLimit:settings.freeUserWithdrawalLimit,
        NewUserContestJoinLimit:settings.NewUserContestJoinLimit,
      });
      console.log("Response:", response.data);
      alert("App controls saved successfully!");
    } catch (error) {
      console.error(error);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative w-full p-6 pt-10">
      {/* Header */}
      <div className="flex justify-between items-center mb-8">
        <h2 className="text-2xl font-bold text-gray-800">App Controls</h2>
        <button
          onClick={handleSubmit}
          disabled={loading}
          className="bg-blue-600 text-white font-semibold rounded-md py-2 px-6 hover:bg-blue-700 transition disabled:bg-gray-400"
        >
          {loading ? "Saving..." : "Save Settings"}
        </button>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6 max-w-3xl">
        {/* Minimum Recharge Amount */}
        <div className="mb-6">
          <label className="block font-medium mb-2 text-gray-700">
            Minimum Recharge Amount (₹)
          </label>
          <input
            type="number"
            name="minRechargeAmount"
            min="0"
            value={settings.minRechargeAmount || ""}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
          <p className="text-sm text-gray-500 mt-1">
            Users cannot recharge less than this amount
          </p>
        </div>

        {/* Minimum Withdrawal Amount */}
        <div className="mb-6">
          <label className="block font-medium mb-2 text-gray-700">
            Minimum Withdrawal Amount (RS)
          </label>
          <input
            type="number"
            name="minWithdrawalAmount"
            min="0"
            value={settings.minWithdrawalAmount || ""}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
          <p className="text-sm text-gray-500 mt-1">
            Users cannot withdraw less than this amount (in RS)
          </p>
        </div>
        {/* Minimum Withdrawal Amount For New user*/}
        <div className="mb-6">
          <label className="block font-medium mb-2 text-gray-700">
            Minimum Withdrawal Amount (RS) For New Users
          </label>
          <input
            type="number"
            name="freeUserWithdrawalLimit"
            min="0"
            value={settings.freeUserWithdrawalLimit || ""}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
          <p className="text-sm text-gray-500 mt-1">
            New Users cannot withdraw more than this amount (in RS)
          </p>
        </div>
        {/* Minimum contest join limit For New user*/}
        <div className="mb-6">
          <label className="block font-medium mb-2 text-gray-700">
            Minimum contest join limit For New Users
          </label>
        <input
  type="number"
  name="NewUserContestJoinLimit"
  min="0"
  value={settings.NewUserContestJoinLimit}
  onChange={handleChange}
  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
/>
          <p className="text-sm text-gray-500 mt-1">
           If user join more than {settings.NewUserContestJoinLimit || ""} contest then user will no longer new user
          </p>
        </div>
        {/* Show Rupees Toggle */}
<div className="border-t pt-6 mt-8">
  <h3 className="text-lg font-semibold text-gray-800 mb-4">
    Display Settings
  </h3>

  <div className="flex items-center justify-between bg-gray-50 border rounded-xl p-4">
    <div>
      <h4 className="font-semibold text-gray-800">Show Rupees (₹)</h4>
      <p className="text-sm text-gray-500 mt-1">
        Enable to display amounts in Rupees instead of Coins.
      </p>
    </div>

    <button
      type="button"
      onClick={() =>
        setSettings((prev) => ({
          ...prev,
          showRupees: !prev.showRupees,
        }))
      }
      className={`relative inline-flex h-7 w-14 items-center rounded-full transition-all duration-300 ${
        settings.showRupees
          ? "bg-green-500"
          : "bg-gray-400"
      }`}
    >
      <span
        className={`inline-block h-5 w-5 transform rounded-full bg-white transition-all duration-300 shadow ${
          settings.showRupees
            ? "translate-x-8"
            : "translate-x-1"
        }`}
      />

      <span
        className={`absolute text-[10px] font-semibold transition-all ${
          settings.showRupees
            ? "left-2 text-white"
            : "right-2 text-white"
        }`}
      >
        {settings.showRupees ? "ON" : "OFF"}
      </span>
    </button>
  </div>
</div>


        {/* Version & Store Controls Section */}
        <div className="border-t pt-6 mt-8">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">Version & Store Controls</h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="mb-4">
              <label className="block font-medium mb-2 text-gray-700">
                Latest Android Version
              </label>
              <input
                type="text"
                name="latestVersionAndroid"
                value={settings.latestVersionAndroid || ''}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
              <p className="text-sm text-gray-500 mt-1">
                Set to '1.0.0' to hide popup, higher version to show update prompt
              </p>
            </div>

            <div className="mb-4">
              <label className="block font-medium mb-2 text-gray-700">
                Latest iOS Version
              </label>
              <input
                type="text"
                name="latestVersionIos"
                value={settings.latestVersionIos || ''}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
              <p className="text-sm text-gray-500 mt-1">
                Latest available iOS version
              </p>
            </div>

            <div className="mb-4">
              <label className="block font-medium mb-2 text-gray-700">
                Min Required Android Version
              </label>
              <input
                type="text"
                name="minRequiredVersionAndroid"
                value={settings.minRequiredVersionAndroid || ''}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
              <p className="text-sm text-gray-500 mt-1">
                Force update if app version is below this
              </p>
            </div>

            <div className="mb-4">
              <label className="block font-medium mb-2 text-gray-700">
                Min Required iOS Version
              </label>
              <input
                type="text"
                name="minRequiredVersionIos"
                value={settings.minRequiredVersionIos || ''}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
              <p className="text-sm text-gray-500 mt-1">
                Force update if app version is below this
              </p>
            </div>
          </div>

          <div className="mb-4">
            <label className="block font-medium mb-2 text-gray-700">
              Play Store URL
            </label>
            <input
              type="url"
              name="playStoreUrl"
              value={settings.playStoreUrl || ''}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>

          <div className="mb-4">
            <label className="block font-medium mb-2 text-gray-700">
              App Store URL
            </label>
            <input
              type="url"
              name="appStoreUrl"
              value={settings.appStoreUrl || ''}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>
        </div>

        {/* Tutorial Controls Section */}
        <div className="border-t pt-6 mt-8">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">Tutorial Controls</h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="mb-4">
              <label className="block font-medium mb-2 text-gray-700">
                Buy Course Tutorial
              </label>
              <input
                type="url"
                name="tutorialBuyCourse"
                value={settings.tutorialBuyCourse || ''}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>

            <div className="mb-4">
              <label className="block font-medium mb-2 text-gray-700">
                Quiz Tutorial
              </label>
              <input
                type="url"
                name="tutorialQuiz"
                value={settings.tutorialQuiz || ''}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>

            <div className="mb-4">
              <label className="block font-medium mb-2 text-gray-700">
                Contest Tutorial
              </label>
              <input
                type="url"
                name="tutorialContest"
                value={settings.tutorialContest || ''}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>

            <div className="mb-4">
              <label className="block font-medium mb-2 text-gray-700">
                Credits Tutorial
              </label>
              <input
                type="url"
                name="tutorialCredits"
                value={settings.tutorialCredits || ''}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>

            <div className="mb-4">
              <label className="block font-medium mb-2 text-gray-700">
                Withdrawal Tutorial
              </label>
              <input
                type="url"
                name="tutorialWithdrawal"
                value={settings.tutorialWithdrawal || ''}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>
          </div>
        </div>

        {/* How Adhyayi Works Section */}
        <div className="border-t pt-6 mt-8">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">How Adhyayi Works</h3>
          <div className="mb-4">
            <label className="block font-medium mb-2 text-gray-700">
              How Adhyayi Works (URL/Content)
            </label>
            <input
              type="url"
              name="howAdhyayiWorks"
              value={settings.howAdhyayiWorks || ''}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
            <p className="text-sm text-gray-500 mt-1">
              Link or content explaining how Adhyayi works
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppControls;
